import { render, staticRenderFns } from "./modal-add-edit-delete-dam-sire-document.vue?vue&type=template&id=29290ed9&scoped=true&lang=pug"
import script from "./modal-add-edit-delete-dam-sire-document.js?vue&type=script&lang=js&external"
export * from "./modal-add-edit-delete-dam-sire-document.js?vue&type=script&lang=js&external"
import style0 from "./modal-add-edit-delete-dam-sire-document.vue?vue&type=style&index=0&id=29290ed9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29290ed9",
  null
  
)

export default component.exports